import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ number, label }) => (
  <div className="flex items-center gap-3 mb-8">
    <span className="h-px w-6 shrink-0 bg-[#7F9F43]/40" />
    <span className="text-xl sm:text-2xl tracking-[0.12em] uppercase text-gray-400 font-semibold whitespace-nowrap">
      {label}
    </span>
  </div>
);
